// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AssetsMigrationSelector_wrapper__2P9XJ","loading":"AssetsMigrationSelector_loading__2dusV","title":"AssetsMigrationSelector_title__TPFEA"};